var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about h-screen flex justify-center mt-20"},[_c('h4',[_vm._v("This is the Prospects Page")])])}]

export { render, staticRenderFns }